export enum BackgroundPositionEnum {
    CONTAIN = 'contain',
    COVER = 'cover',
}
